module.exports = __webpack_public_path__ + "components/country-flag/static/mx-15b0045d8d3f2b33f27656c5069cf2e3.svg";